import styled from 'styled-components';
import { Tooltip } from 'ui/tooltip/Tooltip';
import { Help24 } from 'ui/icons/aurora/24px/Help24';
import { useTranslation } from '../../../hooks/useTranslation';

const StyledTooltip = styled(Tooltip)`
  display: flex;
  align-self: center;
`;

export const TriggerEventTooltip = () => {
  const { t } = useTranslation();
  const tooltipContent = t('selector.triggerEventTooltip');

  return (
    <StyledTooltip tooltipContent={tooltipContent}>
      <Help24 />
    </StyledTooltip>
  );
};
